import CompanyService from '@/store/services/company.service.js';
import CustomerService from '@/store/services/customer.service'
import ProfileService from '@/store/services/profile.service'
import AccountantsService from '@/store/services/accountants.service'
import CommunicationService from '@/store/services/communication.service.js'

export default {
  namespaced: true,
  state: {
    collapsedMenu: false,
    controlPanelCustomer: null,
    controlPanelCustomerProfile: null,
    controlPanelCustomerCompany: null
  },
  getters: {
    getCollapsedMenu: state => state.collapsedMenu,
    getControlPanelCustomer: state => state.controlPanelCustomer,
    getControlPanelCustomerProfile: state => state.controlPanelCustomerProfile,
    getControlPanelCustomerCompany: state => state.controlPanelCustomerCompany,
    getControlPanelProfileId: state => state.controlPanelCustomerCompany.created_by.profile

  },
  mutations: {
    SET_CONTROL_PANEL_CUSTOMER(state, customer) {
      state.controlPanelCustomer = customer
    },
    SET_CONTROL_PANEL_CUSTOMER_PROFILE(state, profile) {
      state.controlPanelCustomerProfile = profile
    },
    SET_CONTROL_PANEL_CUSTOMER_COMPANY(state, company) {
      state.controlPanelCustomerCompany = company
    },
    TOGGLE_MENU(state) {
      state.collapsedMenu = !state.collapsedMenu
    },
  },
  actions: {
    loadControlPanelCustomerData({ dispatch }, customer_id) {
      return Promise.all([
        dispatch('loadControlPanelCustomer', { customer_id: customer_id }),
        dispatch('loadControlPanelCustomerCompany', { customer_id: customer_id })
      ]).then(() => {
        return dispatch('loadControlPanelCustomerProfile')
      })
    },
    unloadControlPanelCustomerData({ commit }) {
      commit('SET_CONTROL_PANEL_CUSTOMER', null)
      commit('SET_CONTROL_PANEL_CUSTOMER_PROFILE', null)
      commit('SET_CONTROL_PANEL_CUSTOMER_COMPANY', null)
    },
    loadControlPanelCustomer({ commit }, params) {
      return CustomerService.retrieve(params.customer_id).then((response) => {
        commit('SET_CONTROL_PANEL_CUSTOMER', response.data)
      })
    },
    loadControlPanelCustomerProfile({ commit, getters }) {
      return ProfileService.retrieve(getters.getControlPanelProfileId).then((response) => {
        commit('SET_CONTROL_PANEL_CUSTOMER_PROFILE', response.data)
      })
    },
    loadControlPanelCustomerCompany ({commit}, params) {
      return CompanyService.getCustomerCompany(params.customer_id).then((response) => {
        commit('SET_CONTROL_PANEL_CUSTOMER_COMPANY', response.data)
      });
    },
    getAccountantConnections({ commit }, filters) {
      return AccountantsService.getAccountantConnectionsV3(filters).then((response) => {
        return response
      })
    },
    getAccountantConnection({ commit }, connection_id) {
      return AccountantsService.getAccountantConnection(connection_id).then((response) => {
        return response
      })
    },
    getAccountantNextListConnections({ commit }, nextListUrl) {
      return AccountantsService.listNextPage(nextListUrl).then((response) => {
        return response
      })
    },
    getPendingInvites ({ commit }) {
      return AccountantsService.getPendingInvites().then((response) => {
        return response
      })
    },
    deleteInvitation({ commit }, invitation_id) {
      console.log('deleteInvitation', invitation_id)
      return AccountantsService.deleteInvite(invitation_id).then(() => {
        commit('setAlert', {
          title: this.getters.getRoot.$gettext('Success!'),
          text: this.getters.getRoot.$gettext('Invite deleted.'),
          variant: 'success',
          duration: 4,
        }, { root: true })
      }).catch(() => {
        commit('setAlert', {
          title: this.getters.getRoot.$gettext('Error'),
          text: this.getters.getRoot.$gettext('Something went wrong.'),
          variant: 'error',
          duration: 4,
        }, { root: true })
      })
    },
    resendInvitation({ commit }, item) {
      console.log('resendInvitation', item)
      return AccountantsService.deleteInvite(item.id).then(() => {
        commit('setAlert', {
          title: this.getters.getRoot.$gettext('Success!'),
          text: `${this.getters.getRoot.$gettext('Invite resent to ')} ${item.invite_to_name}.`,
          variant: 'success',
          duration: 4,
        }, { root: true })
      }).catch(() => {
        commit('setAlert', {
          title: this.getters.getRoot.$gettext('Error'),
          text: this.getters.getRoot.$gettext('Something went wrong.'),
          variant: 'error',
          duration: 4,
        }, { root: true })
      })
    },
    disconnectCustomer({ commit }, customer_id) {
      console.log('disconnectCustomer', customer_id)
      return AccountantsService.getAccountantConnectionList({ customer: customer_id }).then((response) => {
        const connection_id = response.data[0].id
        return AccountantsService.disconnect(connection_id).then((response) => {
          commit('setAlert', {
            title: this.getters.getRoot.$gettext("Success!"),
            text: this.getters.getRoot.$gettext("Your account have been disconnected from  ") + response.data.name + ".",
            variant: "success",
            duration: 4
          }, { root: true })
        })
      })
    },
    reconnectCustomer({ commit }, payload) {
      let customerDetails, accountantConnection
      return AccountantsService.getCustomerInformation(payload.customer_id).then((response) => {
        customerDetails = response.data
        return AccountantsService.getAccountantConnectionList({ customer: customerDetails.id }).then((response) => {
          accountantConnection = response.data[0] // there must be just one connection per customer
          return AccountantsService.getPendingInvites().then((response) => {
            if (response.data.find(o => o.invite_to === customerDetails.email) && accountantConnection.status !== 'connected') {
              accountantConnection.status = 'pending'
            }
            if (!payload.is_gekko_accountant) {
              let data = {
                accountant: accountantConnection.accountant,
                invite_to: customerDetails.email,
                invite_to_name: customerDetails.name,
                message: this.getters.getRoot.$gettext('An accountant would like to connect to you.'),
                company_profile: payload.company_id,
              }
              let re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
              if (re.test(data.invite_to)) {
                return AccountantsService.sendInvite(data)
                  .then((response) => {
                    commit('setAlert', {
                      title: this.getters.getRoot.$gettext('Success!'),
                      text: this.getters.getRoot.$gettext('Invite sent to ') + response.data.invite_to_name + '.',
                      variant: 'success',
                      duration: 4,
                    }, { root: true })
                  })
                  .catch((error) => {
                    commit('setAlert', {
                      title: this.getters.getRoot.$gettext('Pending invitation'),
                      text: error,
                      variant: 'warning',
                      duration: 4,
                    }, { root: true })
                  })
              } else {
                commit('setAlert', {
                  title: this.getters.getRoot.$gettext('Error'),
                  text: this.getters.getRoot.$gettext('Email incorrect or not set.'),
                  variant: 'danger',
                  duration: 4,
                }, { root: true })
              }
            } else {
              return AccountantsService.createGekkoConnection(payload.company_id, customerDetails.id).then((response) => {
                commit('setAlert', {
                  title: this.getters.getRoot.$gettext('Success!'),
                  text: this.getters.getRoot.$gettext('Connected to ') + response.data.name + '.',
                  variant: 'success',
                  duration: 4,
                }, { root: true })
              }).catch((response) => {
                commit('setAlert', {
                  title: this.getters.getRoot.$gettext('Error'),
                  text: response,
                  variant: 'error',
                  duration: 4,
                }, { root: true })
              })
            }
          })
        })
      })
    },
    createGekkoConnection({ commit }, { companyId, customerId }) {
      return AccountantsService.createGekkoConnection(companyId, customerId).then((response) => {
        commit("setAlert", {
          title: this.getters.getRoot.$gettext("Success!"),
          text: this.getters.getRoot.$gettext("Connected to ") + response.data.name + ".",
          variant: "success",
          duration: 4
        }, { root: true })
        return response
      }).catch((response) => {
        commit("setAlert", {
            title: this.getters.getRoot.$gettext("Error"),
            text: response.data,
            variant: "error",
            duration: 4
        }, { root: true })
      })
    },
    getAccountantCommunication(_, comm_id) {
      return CommunicationService.byId(comm_id).then((response) => {
        return response
      })
    }
  }
};
